(function() {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .service('ConsumerChart', ConsumerChart);


  function ConsumerChart($translate, ChartUtil, ConsumerChartDisplay){

    return {
      getChartData : getChartData,
      getXLabelData: getXLabelData,
      getFormattedData: getFormattedData,
      getChartConfig: getChartConfig
    };

    function getChartData(consumerArr, filterCnfg){
      var chartData = filterChartData(consumerArr, filterCnfg);
      return _.map(chartData, function(data) {
        return { date: data.date, value: _.sumBy(data.values, 'value') };
      });
    }

    function getXLabelData(consumerArr){
      return _(consumerArr).map(function(obj){
        return ChartUtil.chartDateParser(obj.date);
      }).value();
    }

    function filterChartData(arr, filterCnfg) {
      return _(arr).map(function (obj) {
        return {
          date: obj.startDate,
          values: _.filter(obj['metricValues'], filterCnfg)
        }
      }).sortBy('date').value();
    }

    /**
     * @chartData array : [{chartLine: chartData},...]
     *
     * @result object: {
     *                   chartLine1: {
     *                              values: [2,4,5,6...],
     *                              color: ['#dffdfd',..],
     *                              label: fn()}
     *                              },
     *                   ...
     *                 }
     *
     */
    function getFormattedData(chartConfig, chartData){
      return _.map(chartConfig.series, function (config) {
        var values = getChartData(chartData, config.filter);
        return {
          values: _(values).map(function(x){ return x.value }).value(),
          dates: _(values).map(function(x){ return x.date }).value(),
          color: config.color,
          data: values,
          labelColor: config.color.stroke,
          label: $translate.instant(config.label),
          stackedTotal: config.stackedTotal
        };
      });
    }

    function getChartConfig(chartType, titleProp, drawAreaChart, detailLevel, tooltipProp, section, optionalParams) {
      return _.merge({
        chartType: chartType,
        title: titleProp,
        drawAreaChart: drawAreaChart,
        detailLevel: detailLevel,
        // Because this cannot be translated in UI
        titleTooltip: $translate.instant(tooltipProp),
        section: section
      }, optionalParams);
    }

  }

})();